var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feedback"},[_c('p',{staticClass:"ma-10"},[_vm._v("Function of \"Feedback\" will be added later.")])])}]

export { render, staticRenderFns }